import { SharedState } from '@trello/shared-state';

export const isCrossFlowIFrameOpenState = new SharedState<boolean>(false);
